import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { AuthContext, Pagination, TableSpec } from 'alurkerja-ui';
import { Notifications } from '@/utils/types/user';
import { useFetch } from '@/hooks/useFetch';

interface TimeAgoProps {
  timestamp: string | undefined;
}

export const Notification: React.FC = () => {
  const axiosInstance = useContext(AuthContext);
  const [pageConfig, setPageConfig] = useState({ limit: 10, page: 0 });

  const { data: notifications, refetch } = useFetch<Notifications>({
    path: `/api/notifications?limit=${pageConfig.limit}&page=${pageConfig.page}&sort=createdDate&asc=false`,
  });

  const { data: tableSpec } = useFetch<TableSpec>({
    path: '/api/notifications/spec',
  });

  const TimeAgo: React.FC<TimeAgoProps> = ({ timestamp }) => {
    const timeAgo = () => {
      const timeDifference = moment().diff(moment(timestamp));
      const duration = moment.duration(timeDifference);

      if (duration.asMinutes() < 1) {
        return 'Beberapa detik yang lalu';
      } else if (duration.asHours() < 1) {
        const minutes = Math.floor(duration.asMinutes());
        return `${minutes} menit yang lalu`;
      } else {
        const hours = Math.floor(duration.asHours());
        if (hours > 24) {
          return `${Math.floor(hours / 24)} hari yang lalu`;
        }
        return `${hours} jam yang lalu`;
      }
    };

    return <p className="mt-2 text-xs text-gray-400">{timeAgo()}</p>;
  };

  const markAllAsRead = async () => {
    try {
      await axiosInstance.post(`/api/notifications/read-all`);
      refetch();
    } catch (error) {
      console.error('Failed to mark all as read:', error);
    }
  };

  return (
    <div className="p-5 bg-white rounded">
      <div className="flex justify-between my-4">
        <p className="text-2xl font-medium">Notifikasi</p>
        <Link className="text-xs text-blue-700" to="#" onClick={() => markAllAsRead()}>
          Tandai Semua Sudah Dibaca
        </Link>
      </div>
      <div className="flex flex-col gap-4">
        {notifications?.content.map((notification) => (
          <button
            key={notification.id}
            className="text-left"
          >
            <div className="relative w-full p-4 mb-1 border border-gray-300 rounded-md">
              {notification.read_at === null && (
                <span className="absolute top-0 right-0 mt-2 mr-2 text-4xl text-red-500">•</span>
              )}
              <p className="text-lg font-semibold">{notification.title}</p>
              <p className="mt-2 text-sm">{notification.message}</p>
              <TimeAgo timestamp={notification.created_at} />
            </div>
          </button>
        ))}
      </div>
      <Pagination
        pagination={notifications}
        tableSpec={tableSpec}
        pageConfig={pageConfig}
        setPageConfig={setPageConfig}
      />
    </div>
  );
};
